import axios from "axios";
import env from "../Env";
import moment from "moment";
export default {
  generatePostIR: function(token, country, PostIRData) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}postir/${country}`;
      axios
        .post(url, PostIRData, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getpostirSows: function(token, typescsv) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      console.log(process.env.VUE_APP_baseUrl);
      let url = `${process.env.VUE_APP_baseUrl}postir/${typescsv}`;
      axios
        .get(url, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
